<!-- <button (click)="addToFavorites($event)">add to favorites</button> -->
<div class="d-flex justify-content-center p-2" style="height: auto;flex-grow: 1;">
  <router-outlet></router-outlet>
</div>
<!-- <footer style="color: #616161;">
  Copyright © 2010 Mike Ze'evi & Sons Diamonds LTD, All Right's Reserved.
</footer> -->
